/* Same-day delivery page: chat buttons, consent-gated GA4 clicks, and the three-question checker. The page works without it. */
(() => {
  'use strict';
  if (window.wnfswSamedayInit) return;
  window.wnfswSamedayInit = true;
  const MID = 'G-0JE425EEKS';
  const allowed = () => window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() === true;
  const track = (name, params = {}) => {
    if (!allowed() || typeof window.gtag !== 'function') return;
    window.gtag('event', name, { send_to: MID, page_location: 'https://whatsnewfurniture.com' + location.pathname, ...params });
  };
  if (!window.Shopify?.customerPrivacy && typeof window.Shopify?.loadFeatures === 'function') {
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], () => {});
  }
  const wire = (root) => {
    const ev = root.dataset.wnfswEvent;
    // Capture phase so this runs before Motion's link handler starts a page transition.
    document.addEventListener('click', (e) => {
      const cta = e.target.closest('[data-wnfsw-cta]');
      if (cta && root.contains(cta)) track(ev, { cta_placement: cta.dataset.wnfswCta, transport_type: 'beacon' });
      const c = e.target.closest('[data-wnfsw-chat]');
      if (c && root.contains(c) && typeof window.WNFChatOpen === 'function') {
        // Motion binds a page-transition click handler to every <a> (it navigates by hand), so stop the event here.
        e.preventDefault();
        e.stopPropagation();
        window.WNFChatOpen(c.dataset.wnfswChat === 'photo' ? { intent: 'photo' } : undefined);
      }
    }, true);
  };

  const R = {
    start: ['Answer the three questions.', 'We’ll point you to the fastest way to get it home.', ''],
    yes: ['Good chance it can.', 'Call us now with the piece and your address. We’ll confirm it and the full charge before you choose same-day delivery.', 'call chat'],
    unsure: ['Let’s check together.', 'Call or chat with the piece’s name and your address, and we’ll look it up.', 'call chat'],
    stock: ['It can’t come today.', 'Order it and we’ll call to schedule as soon as it’s ready. Ask us for the typical time for that piece.', 'chat rates'],
    area: ['Standard delivery is your best bet.', 'We schedule delivery once your order is ready. Rates by area are on our delivery page.', 'rates chat'],
    time: ['Call before 1 PM on the day you want it.', 'Or come in today: many in-stock pieces can go home with you the same day.', 'visit call']
  };
  const BTN = {
    call: '<a class="wnfs-button wnfs-button-light" href="tel:+15032353454" data-wnfsw-cta="checker-call">Call (503) 235-3454</a>',
    chat: '<a class="wnfs-text-link js-no-transition" href="/pages/contact-us" data-wnfsw-chat="chat" data-wnfsw-cta="checker-chat">Ask in chat</a>',
    rates: '<a class="wnfs-text-link" href="/pages/shipping-rates" data-wnfsw-cta="checker-rates">See delivery rates</a>',
    visit: '<a class="wnfs-button wnfs-button-light js-no-transition" href="#wnfs-showrooms" data-wnfsw-cta="checker-visit">Visit a showroom today</a>'
  };
  const checker = (root) => {
    const box = root.querySelector('[data-wnfsw-checker]');
    if (!box) return;
    const out = box.querySelector('[data-wnfsw-result]');
    const a = {};
    const paint = () => {
      let k = 'start';
      const v = Object.values(a);
      if (a.stock === 'no') k = 'stock';
      else if (a.area === 'no') k = 'area';
      else if (a.time === 'no') k = 'time';
      else if (v.includes('unsure')) k = 'unsure';
      else if (v.length === 3) k = 'yes';
      const [t, p, b] = R[k];
      out.innerHTML = '<strong>' + t + '</strong><p>' + p + '</p>' + (b ? '<div class="wnfsw-sd-actions">' + b.split(' ').map((x) => BTN[x]).join('') + '</div>' : '');
      if (k !== 'start') track(root.dataset.wnfswEvent.replace('_cta_click', '_checker'), { checker_result: k });
    };
    box.querySelectorAll('[data-q]').forEach((f) => f.addEventListener('click', (e) => {
      const b = e.target.closest('button');
      if (!b) return;
      f.querySelectorAll('button').forEach((x) => x.setAttribute('aria-pressed', x === b ? 'true' : 'false'));
      a[f.dataset.q] = b.value;
      paint();
    }));
    box.classList.add('is-ready');
  };
  const init = () => {
    const root = document.querySelector('[data-wnfsw-service-page][data-wnfsw-event]');
    if (!root) return;
    wire(root);
    checker(root);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
